module.exports = __webpack_public_path__ + "img/project_background.2900898b.png";